import i18n from '@/i18n';

/*
    Scrollbehaviour (to, from, savedposition)
    - to.params.scrollTo
    - savedPosition = { x, y } or { selector: hash }
    - to.hash
    - to.meta.scrollTop (false, number of hash);
    - defaults to top (0,0)
*/
export function scrollBehavior(to, from, savedPosition) {
    if (typeof to.params.scrollTo !== 'undefined') {
        return to.params.scrollTo;
    }
    if (savedPosition) {
        return savedPosition;
    }
    if (to.hash) {
        return { selector: to.hash };
    }
    if (to.meta) {
        if (to.meta.scrollTop === false) { return false; }
        if (to.meta.scrollTop) {
            if (!Number.isNaN(to.meta.scrollTop)) {
                return { x: 0, y: to.meta.scrollTop };
            }
            return { selector: to.meta.scrollTop };
        }
    }
    return { x: 0, y: 0 };
}

/*
    Pagetitle (to)
    Params
    - store.state.app.name
    - store.state.app.base_url
    - store.state.app.name_separator
    - store.state.app.meta.description
    - store.state.app.meta.image

    - to.meta.name
    - to.meta.name_only (does not append appname to meta name)
    - to.meta.description
    - to.meta.image

    - to.meta.dont_update_head -> does not update meta-tags in head
*/
export function meta(to) {
    const { app } = store.state;
    let title = app.name;

    if (to.meta && to.meta.name) {
        let { name } = to.meta;
        if (typeof to.meta.name === 'function') {
            name = to.meta.name(to);
        }
        title = to.meta.name_only ? name : `${name}${app.name_separator}${title}`;
    }


    if (title.indexOf('%') > -1) {
        title = title.replace(/%(\w.+)%/g, (m, m1) => {
            const parts = m1.split('.');
            let val = to.params[parts[0]];
            if (val && parts[1] === 'translate') {
                const translatepart = parts.slice(2, 4).join('.').replace('prop', val);
                val = i18n.t(translatepart);
            }
            return val || '';
        });
    }

    document.title = title;
    if (!to.meta.update_meta === false && app.update_meta) {
        let desc = app.meta.description;
        let img = app.meta.image;
        const url = app.base_url + to.fullPath;

        if (to.meta) {
            if (to.meta.description) { desc = to.meta.description; }
            if (to.meta.image) { img = to.meta.image; }
        }

        const title_items = document.head.getElementsByClassName('meta__title');
        for (let i = 0, len = title_items.length; i < len; i += 1) {
            title_items[i].setAttribute('content', title);
        }

        const url_items = document.head.getElementsByClassName('meta__url');
        for (let i = 0, len = url_items.length; i < len; i += 1) {
            url_items[i].setAttribute('content', url);
        }
        document.head.getElementsByClassName('canonical__url')[0].setAttribute('href', url);

        const desc_items = document.head.getElementsByClassName('meta__desc');
        for (let i = 0, len = desc_items.length; i < len; i += 1) {
            desc_items[i].setAttribute('content', desc);
        }

        const img_items = document.head.getElementsByClassName('meta__image');
        for (let i = 0, len = img_items.length; i < len; i += 1) {
            img_items[i].setAttribute('content', img);
        }
    }
}

export default scrollBehavior;
